import { useState } from 'react';
import { History } from 'lucide-react';
import { Section } from './shared';

const heure = (iso) => new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

const COULEURS = { validation: 'bg-emerald-500', devalidation: 'bg-amber-500', devalidation_auto: 'bg-red-500', non_applicable: 'bg-slate-400', applicable: 'bg-slate-400' };

export const HistoriqueSection = ({ historique = [] }) => {
  const [tout, setTout] = useState(false);
  const visibles = tout ? historique : historique.slice(0, 5);
  return (
    <Section titre="Historique" icone={History} compteur={historique.length} testId="qualiopi-historique">
      {historique.length === 0 ? <p className="text-sm text-slate-400">Aucun mouvement pour l'instant. Chaque validation et chaque preuve ajoutée ou retirée sera notée ici.</p> : (
        <ol className="relative space-y-3 border-l-2 border-slate-100 pl-4">
          {visibles.map((h) => (
            <li key={h.histo_id} className="relative text-sm" data-testid={`qualiopi-historique-${h.histo_id}`}>
              <span className={`absolute -left-[23px] top-1.5 h-3 w-3 rounded-full border-2 border-white ${COULEURS[h.action] || 'bg-[#8DC63F]'}`} />
              <p className="font-medium text-[#0F172A]">{h.libelle}{h.detail ? <span className="font-normal text-slate-500"> · {h.detail}</span> : null}</p>
              <p className="text-xs text-slate-400">{heure(h.date)}{h.par_nom ? ` · ${h.par_nom}` : ''}</p>
            </li>
          ))}
        </ol>
      )}
      {historique.length > 5 && (
        <button type="button" onClick={() => setTout(!tout)} className="text-xs font-medium text-[#5a8a1f] hover:underline" data-testid="qualiopi-historique-tout">
          {tout ? 'Afficher moins' : `Afficher tout (${historique.length})`}
        </button>
      )}
    </Section>
  );
};
